import { render, staticRenderFns } from "./servicechart.vue?vue&type=template&id=108cf0ad&scoped=true&"
import script from "./servicechart.vue?vue&type=script&lang=js&"
export * from "./servicechart.vue?vue&type=script&lang=js&"
import style0 from "./servicechart.vue?vue&type=style&index=0&id=108cf0ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108cf0ad",
  null
  
)

export default component.exports